module.exports = __webpack_public_path__ + "img/167E76_36D6D2_23B2AC_27C1BE-256px.49d6841d.png";